import {
  isPlainObject,
  isRichTextDocument,
  PlainObject,
} from '../helpers/helpers';

export const createFieldNameConverter = (
  fieldNames: Record<string, string> = {}
) => {
  const toFieldName = (apiFieldName: string): string =>
    fieldNames[apiFieldName] ?? apiFieldName;

  const convertFieldNames = (value: unknown): unknown => {
    if (Array.isArray(value)) return value.map(convertFieldNames);

    if (!isPlainObject(value) || isRichTextDocument(value)) return value;

    const converted: PlainObject = {};

    Object.entries(value).forEach(([apiFieldName, fieldValue]) => {
      converted[toFieldName(apiFieldName)] = convertFieldNames(fieldValue);
    });

    return converted;
  };

  return {
    toFieldName,
    convertFieldNames,
    metadataFieldName: toFieldName('_metadata'),
  };
};

export type FieldNameConverter = ReturnType<typeof createFieldNameConverter>;
